"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment = require("moment");

var MomentProvider =
/*#__PURE__*/
function () {
  function MomentProvider() {
    _classCallCheck(this, MomentProvider);
  }

  _createClass(MomentProvider, [{
    key: "fromDate",
    value: function fromDate(date) {
      return {
        instance: moment(date),
        fromCache: false
      };
    }
  }, {
    key: "fromString",
    value: function fromString(stringValue, pattern) {
      return {
        instance: moment(stringValue, pattern, true),
        fromCache: false
      };
    }
  }, {
    key: "startup",
    value: function startup() {// nothing to do
    }
  }, {
    key: "shutdown",
    value: function shutdown() {// nothing to do
    }
  }]);

  return MomentProvider;
}();

exports.MomentProvider = MomentProvider;